    import { useState, useEffect,useRef,useContext} from 'react';
    import '../assets/css/views/recargas.css'
    import { useModal } from '../hooks/useModal'
    import { useSpinner } from '../hooks/useSpinner'
    import { AuthFetch, Fetch } from '../services/api'
    import { formatDate, notify, soloDecimal, formatState,formatoNombre } from '../utils/utils'
    import { UserContext } from "../context/provider/UserProvider";

    export const useReportes = () => {
        const { stateUser , signOut } = useContext(UserContext);
        const [ recargasReporte, setRecargasReporte ] = useState()

        const listarRecargasReporte = async (FechaInicio,FechaFin,codEntidadFinanciera, uidRecargador) => {
            const response = await AuthFetch('/Report/recharge?' + new URLSearchParams({
                fechaInicio:formatDate(FechaInicio,23) || new Date().toDateString() ,
                fechaFin:formatDate(FechaFin,23) || new Date().toDateString(),
                codEntidadFinanciera: codEntidadFinanciera,
                uidRecargador: uidRecargador || "hcerna",
            }), {
                method: 'GET'
            })

            if (response.isValid) {
                setRecargasReporte(response.content)
            } else {
                notify(response.exceptions[0].description, 'error')
            }
        }

        return {
            listarRecargasReporte,
            recargasReporte,
        };
    }